import { useEffect, useState } from "react";

import { useFormik } from "formik";

import { Button } from "primereact/button";
import { Sidebar } from "primereact/sidebar";

import CheckboxInput from "../Inputs/CheckboxInput";
import DropdownInput from "../Inputs/DropdownInput";

import commonStyle from "../../content/CommonStyles.module.css";

import useApi from "../../../Utils/BackendClient";
import AttributeCreationSidebar from "./AttributeCreationSidebar";

const ProductGroupFieldAddingSidebar = ({visible, onHide, data, onSelect, toast}) => {

    const { fetchProductAttributes } = useApi();

    const [attributes, setAttributes] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [atrSidebarvisible, setAtrSidebarVisible] = useState(false);

    useEffect(() => {

        const getAttributes = async () => {
            const response = await fetchProductAttributes({
                first: 0,
                rows: 100,
                page: 1,
                sortField: null,
                sortOrder: null,
                filters: {
                    id: { value: "", matchMode: 'equals' },
                }
            });

            if (response.status === 200) {
                console.log(response.data.results);
                const convertedAttributes = response.data.results.map(i => ({ value: i.id, label: i.name, type: i.type }));
                setAttributes(convertedAttributes);
            }

            setIsLoaded(true);
        }

        if (visible && !isLoaded) {
            getAttributes();
        }
    }, [visible, fetchProductAttributes, isLoaded]);

    const formik = useFormik({
            initialValues: data ?? {
                attribute_id: null,
                name: null,
                type: null,
                is_filterable: false,
                is_required: false,
            },
            enableReinitialize: true,
            validate: values => {
                const errors = {};
    
                if (!values.attribute_id) {
                    errors.field_name = "Виберіть атрибут";
                }
    
                return errors;
            },
            onSubmit: values => {

                const isEdit = data ? true : false;
                onSelect(isEdit, values);
    
                formik.resetForm();
                onHide();
            }
    });

    const setAttributeValue = (id) => {
        const attribute = attributes.find(x => x.value === id);
        formik.setFieldValue("name", attribute.label);
        formik.setFieldValue("type", attribute.type);
        if(attribute.type === "DICTIONARY"){
            formik.setFieldValue("is_filterable", true);
        }
        formik.setFieldValue("attribute_id", id);
    }

    const ResetAttributes = () => {
        setIsLoaded(false);
    }

    return (<Sidebar visible={visible} position="right" className={`${commonStyle.sidebar} ${atrSidebarvisible ? commonStyle.moveLeft : ""}`} onHide={onHide} header={<h3>Меню додавання поля до групи товару</h3>}>
        <form onSubmit={formik.handleSubmit}>
            <DropdownInput 
                formik={formik}
                paramName="attribute_id"
                context={attributes}
                label="Атрибут"
                onChange={(val) => setAttributeValue(val)}
                customStyle="w-full"
                isDisabled={data}
                mandatory 
                addButton={true}
                addButtonTooltip={"Додати атрибут"}
                addButtonAction={() => setAtrSidebarVisible(true)}/>
            <CheckboxInput formik={formik} paramName={"is_required"} label={"Обов'язкове поле"} customStyle="w-full"/>
            <Button label={data ? "Змінити" : "Додати"} severity="success" type="submit" className={`${commonStyle.sideBarButton} ${commonStyle.addButton}`} autoFocus />
        </form>
        <AttributeCreationSidebar visible={atrSidebarvisible} onHide={() => setAtrSidebarVisible(false)} toast={toast} additionalActions={() => ResetAttributes()}/>
    </Sidebar>)
}

export default ProductGroupFieldAddingSidebar;